import * as z from 'zod';
import { Create as Create$1 } from './bid-contract-surety-bond-issuance.dto.mjs';
import * as bidContractSuretyBondIssuance_dto from './bid-contract-surety-bond-issuance.dto.mjs';
export { bidContractSuretyBondIssuance_dto as Bid };
import { Create as Create$2 } from './bid-to-final-contract-surety-bond-issuance.dto.mjs';
import * as bidToFinalContractSuretyBondIssuance_dto from './bid-to-final-contract-surety-bond-issuance.dto.mjs';
export { bidToFinalContractSuretyBondIssuance_dto as BidToFinal };
import { Create as Create$3 } from './final-contract-surety-bond-issuance.dto.mjs';
import * as finalContractSuretyBondIssuance_dto from './final-contract-surety-bond-issuance.dto.mjs';
export { finalContractSuretyBondIssuance_dto as Final };

var Create;
(function (Create) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("contractSuretyType", [
            Create$1.Request.schema,
            Create$2.Request.schema,
            Create$3.Request.schema,
        ]);
    })(Create.Request || (Create.Request = {}));
})(Create || (Create = {}));

export { Create };
